export async function uploadDirect(sasUrl: string, file: File): Promise<void> {
  const res = await fetch(sasUrl, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "content-type": file.type,
    },
    body: file,
  });
  if (!res.ok && res.status !== 201) {
    throw new Error(`Upload failed: ${res.status}`);
  }
}
